import React, { Component } from 'react';
import styled from "styled-components";
import { history } from "../../utils";
import { getTestSummary, getResults } from '../../lib/api';
import Flex from 'styled-flex-component';
import TestSummary from './TestSummary';
import TestAnalysis from './TestAnalysis';
import TestMessage from '../TestMessage';

const LayoutWrapper = styled.div`
    height: 100vh;
    overflow: auto;
    background-color: white;
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-overflow-scrolling: touch;
`

const Color = styled.div`
    width:16px;
    height:16px;
    background: ${({ color }) =>
    color ? color : 'white'};
    display:inline-block;
    margin-right:10px;

`


const StyledTable = styled.table`
  margin-top:50px;
  border-collapse: collapse;
  width: 100%;
  tbody tr{
    td, th {
    /* border: 1px solid #dddddd; */
    text-align: left;
    padding: 8px;
  }
  }
  
`
const StyledTabs = styled.div`
  padding:8px;
  padding-bottom: 0;
  padding-top: 18px;
  background-color: white;
  position: fixed;
  top: 0;
  width: 100%;
  height: auto;
  z-index: 10;
  overflow: hidden;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

const StyledTab = styled.div`

  font-size:14px;
  padding: 6px 30px;
  padding-bottom: 5px;
  font-weight: 600;
  color: #827e7e;
`
const StyledActiveTab = styled.div`
  padding: 6px 30px;
  font-size: 14px;
  font-weight: 600;
  color: black;
  border-bottom: 2px solid black;
  padding-bottom: 5px;
`

const StyledTabContent = styled.div`
  padding-top:20px;
  padding-bottom:100px;
  margin-top: 70px;
`

let tabs = ['SUMMARY', 'ANALYTICS'];
class TakeTestOverview extends Component {
  constructor(props) {
    super(props);
    //this.pieChart = React.createRef();
  }

  state = {
    response: null,
    loading: true,
    tid: null,
    activeTab: 'SUMMARY'
  };

  callbackToNative = (msg) => {
    try {
      if (window.webkit != undefined) {
        window.webkit.messageHandlers.observe.postMessage(msg);
        window.webkit.messageHandlers.appInterface.postMessage(msg)
      }
      if (window.appInterface != undefined) {
        window.appInterface.postMessage(msg)
      }
    } catch (error) {
      console.log(msg);
      console(error);
    }
  }

  checkNative = () => {
    try {
      if ((window.webkit) || window.appInterface)
        return true;
      else return false;
    } catch (error) {
      console.log(error);
    }
  }


  doneResults = async () => {
    this.doneHandle();
  };

  doneHandle = () => {

    let bool = this.checkNative();
    console.log(bool)
    if (bool) {
      this.callbackToNative("done");
      console.log('done called');
    } else {
      window.location.href = '/';
      console.log('done called');
    }
  }

  async componentDidMount() {
    try {
      let tid = this.props.match.params.tid;

      let response = await getTestSummary(tid);
      let response1 = await getResults(tid);

      // console.log(response)
      // console.log(response1)

      // Handling Response error
      if (!response || !response1) {
        this.setState({ loading: false, tid: tid, status: response?.status});
        throw(new Error('Error  : No Response'))
      };

      let res_sec = response.summary[0].sections
      let sec_ques = []
      let res_tpq = response.summary[0].time_per_question
      let res_ques = response1.questions
      let tpq = []
      let ques = []
      for (let i = 0; i < res_sec.length; i++) {
        sec_ques = [...sec_ques, ...res_sec[i].questions]
      }
      for (let i = 0; i < sec_ques.length; i++) {
        tpq[i] = res_tpq.filter(t => t.question_id == sec_ques[i])[0];

      }
      for (let i = 0; i < sec_ques.length; i++) {
        ques[i] = res_ques.filter(t => t.id == sec_ques[i])[0];

      }
      response.summary[0].time_per_question = tpq.length !== 0 ? tpq : res_tpq;
      response1.questions = ques.length !== 0 ? ques : res_ques;
      const { current_date, doe } = response.summary[0].test_details;
      this.setState({ current_date, doe });

      let sections_dict = {}
      if (response.summary[0].sections && response.summary[0].sections.length != 0) {
        response.summary[0].sections.map((sec) => {
          sections_dict[sec.id] = sec;
          sections_dict[sec.id]['question_indexes'] = []
        })
        response1.questions.map((ques, index) => {
          sections_dict[ques.section_id]['question_indexes'].push(index);
        })
      }
      response1.questions = response1.questions.sort((q1,q2) => q1.id - q2.id);
      this.setState({ response: response.summary[0], loading: false, tid: tid, sections_dict: sections_dict, status: response.status, questions: response1.questions });
    } catch (error) {
      console.log(error);
      this.setState({ response: null, loading: false });
    }
  }

  viewResults = () => {
    history.push(`/testResults/${this.state.tid}/0`);
  }
  changeTab = (event) => {
    let tab = this.state.activeTab;
    if (tab === 'SUMMARY') {
      this.setState({ activeTab: 'ANALYTICS' })
    } else {
      this.setState({ activeTab: 'SUMMARY' })
    }
  }

  render() {
    console.log(this.state.activeTab)
    if (this.state.loading) {
      return <LayoutWrapper>
        <p style={{ textAlign: 'center' }}>Please wait</p>
      </LayoutWrapper>
    }
    let response = this.state.response;
    let status = this.state.status;
    let questions = this.state.questions;
    if (!response || (response && status != 200)) {
      return <TestMessage callback={''} message={'Something went wrong.'}/>
      // return <div style={{ marginTop: '30px', textAlign: 'center' }}>
      //   <div style={{ width: '50px', cursor: 'pointer' }}>
      //     <img onClick={() => this.callbackToNative('done')} src="/images/back.svg"></img>
      //   </div>
      //   <h3>Something went wrong. </h3>
      // </div>
    }
    let ct = new Date(this.state.current_date);
    ct.setHours(ct.getHours() + 5);
    ct.setMinutes(ct.getMinutes() + 30);
    let doe = new Date(this.state.doe)
    if (ct < doe) {
      return <div style={{ marginTop: '30px', textAlign: 'center' }}>
        <div style={{ width: '50px', cursor: 'pointer' }}>
          <img onClick={() => this.callbackToNative('done')} src="/images/back.svg"></img>
        </div>
        <h3>Test not completed! Test results will be available after test end time i.e., {this.state.doe}!</h3>
      </div>
    }

    return <div style={{ overflowY: 'scroll', WebkitOverflowScrolling: 'scroll' }}>
      <StyledTabs>
        <div style={{ width: '50px', cursor: 'pointer', color: 'white', marginBottom: '10px' }}>
          <img style={{ color: 'white' }} onClick={this.doneResults} src="/images/back.svg"></img>
        </div>
        <Flex direction="row" justifyCenter alignCenter justifyAround>
          {tabs.map((tab, index) => (
            this.state.activeTab === tab ? <StyledActiveTab key={index} onClick={() => this.changeTab(tab)} >
              {tab}
            </StyledActiveTab> : <StyledTab key={index} onClick={() => this.changeTab(tab)} >
              {tab}
            </StyledTab>

          ))}
        </Flex>
      </StyledTabs>
      <LayoutWrapper>
        <StyledTabContent>
          {!this.state.loading &&
            <div>
              {this.state.activeTab === 'SUMMARY' ?
                <TestSummary response={response} tid={this.state.tid} questions={questions} sections_dict={this.state.sections_dict} viewQuestion={(qid) => this.viewResults(qid)}></TestSummary>
                : <TestAnalysis response={response} tid={this.state.tid} questions={questions}></TestAnalysis>
              }
            </div>}
        </StyledTabContent>
      </LayoutWrapper>
    </div>
  }
}




export default TakeTestOverview;